module.exports = __webpack_public_path__ + "static/media/Picture76.59cb1c42.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture76.PNG
// module id = 1553
// module chunks = 0